<template lang="pug">
  header#header
    #top
      nav-list(v-for="(items, k) in navigation"
          :key="`nav-${k}`"
          :items="items"
          :collapsible="k === 'left'"
          :class="k"
        )
    #bottom
      slot
</template>

<script>
import NavList from './fragments/NavList'
export default {
  name: 'HeaderComponent',
  components: {
    NavList
  },
  data () {
    return {
      navigation: {
        left: [
          // {to: {name: 'home'}, label: this.$t('labels.navigation.home')},
          {to: {name: 'content-page', params: {type: 'pages', id: 83}}, label: this.$t('labels.navigation.project')},
          {to: {name: 'content-page', params: {type: 'pages', id: 107}}, label: this.$t('labels.navigation.process')},
          {to: {name: 'content-page', params: {type: 'posts', id: 130}}, label: this.$t('labels.navigation.lite')},
          {to: {name: 'content-page', params: {type: 'pages', id: 135}}, label: this.$t('labels.navigation.publications')},
          {to: {name: 'content-page', params: {type: 'pages', id: 46}}, label: this.$t('labels.navigation.about')}
        ],
        right: [
          /* {
            label: this.$i18n.locale === 'de' ? 'en' : 'de',
            fn: () => {
              this.$eventbus.$emit('set-locale', this.$i18n.locale === 'de' ? 'en' : 'de')
              this.$router.go(0)
            }
          } */
        ]
      },
      open: {}
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="stylus">
@import '../css/vars'

header

  #top
    width 100%
    position relative
    height 4rem

    @media screen and (max-width: $media-query-width-laptop)
      height 3.5rem

    >>> nav
      overflow hidden
      background-color $color-bg-light-gray
      font-size 0.9rem
      text-transform uppercase

      @media screen and (max-width: $media-query-width-tablet)
        font-size 0.7rem

      &.left
        float left
        max-width calc(100vw - 4rem)
        height 2.5rem

      @media screen and (max-width: $media-query-width-tablet-s)
        &.left.open
          float none
          position absolute
          top 0
          left 0
          right 0
          bottom 0
          max-width none
          width 100vw
          height 6rem

      &.right
        float right
        width 4rem

      ul
        padding-top 1rem
        padding-left 1.25rem

        li
          float left
          border-radius 2em
          padding-left 0.5rem
          padding-right 0.5rem
          margin-right 0.5rem
          background-color inherit
          color inherit
          transition background-color 0.25s ease-in, color 0.25s ease-out

          &:hover
          &.active
            background-color $color-font-dark-gray
            color $color-bg-light-gray

  #bottom
    overflow hidden
    overflow -moz-scrollbars-none
    -ms-overflow-style none
    scrollbar-width none
    &::-webkit-scrollbar
      display none

    overflow-x scroll

</style>



// WEBPACK FOOTER //
// src/components/HeaderComponent.vue